module.exports = __webpack_public_path__ + "img/logo-small.d2117dbd.png";